import { zl } from "../../../../functions/utilities";

const MieszkaniecDaneWodaRozliczenieWydrukPodsumowanie = props => {
    
    const { procent } = props;    

    return (
        <section style={{display: "flex", justifyContent: "center", fontSize: "0.85rem"}}>
            <table>
                <tbody style={{fontSize: "0.7rem"}}>
                    <tr>
                        <td style={{textDecoration: "underline"}}>
                            Łącznie naliczone zaliczki:
                        </td>
                        <td style={{textAlign: "right", padding: "5px 10px"}}>
                            {zl(procent?.zaliczka_razem)}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Koszt zużycia wody:
                        </td>
                        <td style={{textAlign: "right", padding: "5px 10px"}}>
                            {zl(procent?.razemZwCwAbo * -1)}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Straty wody:
                        </td>
                        <td style={{textAlign: "right", padding: "5px 10px", borderBottom: "1px solid black"}}>
                            {zl(procent?.strataMieszkancaKwota * -1)}
                        </td>
                    </tr>
                    <tr style={{fontWeight: "600"}}>
                        <td>
                            { procent?.opis }
                        </td>
                        <td style={{textAlign: "right"}}>
                            {zl(procent?.saldo)}
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>
    )
}

export default MieszkaniecDaneWodaRozliczenieWydrukPodsumowanie;